import React, { useState } from 'react';
import { motion } from 'framer-motion';
import CoverImage from '../assets/img/Cover/Cover4.webp';
import Contact from '../pages/Contact';

// Dynamically import all .webp images from the Gallery folder
const importImages = () => {
  const images = [];
  const context = require.context('../assets/img/Gallery', false, /\.webp$/); // Adjust the path if necessary

  context.keys().forEach((key) => {
    images.push(context(key));
  });

  return images;
};

const Gallery = () => {
  const images = importImages();
  const [modalImage, setModalImage] = useState(null);

  // Open the modal with the clicked image
  const openModal = (image) => {
    setModalImage(image);
  };

  // Close the modal
  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <>
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-[60vh] md:h-[80vh] text-white flex items-center justify-center"
        style={{ backgroundImage: `url(${CoverImage})` }}
      >
        <div className="bg-black bg-opacity-60 absolute inset-0" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-3xl md:text-4xl lg:text-4xl font-bold uppercase mt-4 p-4 tracking-wider inline-block font-playfair animate-fade-up">Gallery</h1>
          <p className="text-xl md:text-2xl font-light uppercase mt-2 tracking-wider font-playfair animate-fade-up">
            Explore our gallery, where we showcase <br/>impactful moments from our projects.
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="mx-auto w-[90%] lg:w-[80%] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {images.map((image, index) => (
            <motion.div
              key={index}
              className="relative overflow-hidden rounded-lg shadow-xl cursor-pointer"
              onClick={() => openModal(image)}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }} // Add staggered fade-in effect
            >
              <img
                src={image}
                alt=''
                className="w-full h-full object-cover rounded-lg transition-all duration-300 transform hover:scale-105"
              />
              {/* Add a subtle overlay effect on hover */}
              <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Modal for Enlarged Image */}
      {modalImage && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-20"
          onClick={closeModal}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <motion.img
            src={modalImage}
            alt="Enlarged"
            className="max-w-4xl max-h-screen object-contain rounded-lg shadow-2xl"
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          />
        </motion.div>
      )}

      {/* Contact Section */}
      <section>
        <Contact />
      </section>
    </>
  );
};

export default Gallery;
